import React from 'react'
import { useTranslation } from 'react-i18next'

import IconEnvelope from 'assets/icons/envelope.png'

function ContactUs() {
  const { t } = useTranslation()

  return (
    <div className="contact-us" id="landing-contact-us">
      <h2 className="contact-use__title">{t('landing.contact_us.title')}</h2>
      <div className="contact-us__email-box">
        <div className="contact-us__icon-box">
          <img src={IconEnvelope} alt="Email" className="contact-us__icon" />
        </div>
        <a
          href={`mailto:${t('landing.contact_us.email')}`}
          rel="noreferrer noopener"
          className="contact-us__link"
        >
          {t('landing.contact_us.email')}
        </a>
      </div>
    </div>
  )
}

export default ContactUs
